import { createAsyncThunk } from "@reduxjs/toolkit";
import { setIsAddingToBasket } from "../basket";
import { create_basket } from "../../../../api/calls/basket/create_basket";
import { add_to_basket } from "../../../../api/calls/basket/add_to_basket";
import { setDrawerOpen, setDrawerPage, setMainModal } from "../../main";
import { calculate_basket_thunk } from "./calculate_basket_thunk";
export const add_product_thunk = createAsyncThunk("basket/thunks/add_product_thunk", async (item, { dispatch, getState }) => {
    const state = getState();
    const { basket } = state.basketState;
    const { user } = state.userState;
    const { branch } = state.selectionState;
    dispatch(setIsAddingToBasket({ id: item.product._id, isAddingToBasket: true }));
    if (user.user._id) {
        //1. Check if we have an existing basket
        //2. If we have an existing basket, add the product to the basket
        //3. If we don't have an existing basket, create a new basket and add the product to the basket
        let basketID = basket?._id;
        if (!basket) {
            //Create new basket
            let response = await create_basket({
                user_id: user.user._id,
                branch_id: branch?._id ?? "",
            });
            if (response.success) {
                basketID = response.content._id;
            }
            else {
                dispatch(setIsAddingToBasket({ id: "", isAddingToBasket: false }));
                dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
                return;
            }
        }
        if (basketID) {
            if (item.selectedVariations) {
                await add_to_basket({
                    _id: basketID,
                    product: {
                        _id: item.product._id,
                        quantity: item.quantity.toString(),
                        variations: item.selectedVariations.map((variant) => {
                            return {
                                _id: null, // the id of the object from which ref was obtained && can be null for now.
                                ref: variant.ref,
                            };
                        }),
                    },
                }).then((response) => {
                    if (response.success) {
                        dispatch(calculate_basket_thunk(response));
                    }
                    else {
                        dispatch(setIsAddingToBasket({ id: "", isAddingToBasket: false }));
                        dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
                    }
                });
            }
            else {
                await add_to_basket({
                    _id: basketID,
                    product: {
                        _id: item.product._id,
                        quantity: item.quantity.toString(),
                    },
                }).then((response) => {
                    if (response.success) {
                        dispatch(calculate_basket_thunk(response));
                    }
                    else {
                        dispatch(setIsAddingToBasket({ id: "", isAddingToBasket: false }));
                        dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
                    }
                });
            }
        }
    }
    else {
        dispatch(setIsAddingToBasket({ id: "", isAddingToBasket: false }));
        dispatch(setDrawerPage("login"));
        dispatch(setDrawerOpen(true));
    }
});
